import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import { useHeadbandContext } from 'contexts/headband'
import { translation } from 'I18n/i18n'
import { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
export default function HSESalarie() {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const { setCounter, counterDefault } = useCounterContext()
   const { setHeadband } = useHeadbandContext()
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'hse', 'title'))
      setAnchorButton(translation(lang, 'hse', 'anchorBtns'))
   }, [])

   return (
      <ScrollContainer>
         <AnchorPart anchor={{partName: 'POLITIQUES ET CONTACTS HSE', id:0}} />
         <ScrollSection zoneName='Politiques-Contacts HSE'  />
         <AnchorPart anchor={{partName: 'EPI', id:1}} />
         <ScrollSection zoneName='EPI'  />
         <AnchorPart anchor={{partName: 'PTI', id:2}} />
         <ScrollSection zoneName='PTI'  />
         <AnchorPart anchor={{partName: 'HABILITATIONS AU POSTE DE TRAVAIL', id:3}} />
         <ScrollSection zoneName='Habilitations au poste'  />
         <AnchorPart anchor={{partName: 'ALERTES ACCIDENTS ET CROIX VERTE', id:4}} />
         <ScrollSection zoneName='Alertes accidents-Croix verte'  />
         <AnchorPart anchor={{partName: 'DÉCHETS ET POLLUTION', id:5}} />
         <ScrollSection zoneName='Déchets-Pollution'  />
         <AnchorPart anchor={{partName: 'PASS (Risk factor)', id:6}} />
         <ScrollSection zoneName='PASS'  />
      </ScrollContainer>
   )
}
